<template>
  <div class="container" style="margin-top: 80px;">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1 class="main-title">模拟填报记录</h1>
      <p class="subtitle">查看您的所有模拟志愿填报历史记录</p>
    </div>

    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <el-spin size="large" tip="加载中..."></el-spin>
    </div>

    <!-- 记录列表 -->
    <div v-else class="record-list">
      <div v-if="records.length === 0" class="empty-state">
        <el-icon class="empty-icon" size="64">
          <DocumentEmpty />
        </el-icon>
        <p>暂无模拟填报记录</p>
        <el-button type="primary" @click="goToMock">去模拟填报</el-button>
      </div>

      <div v-else>
        <div 
          v-for="record in records" 
          :key="record.id" 
          class="record-card"
        >
          <div class="record-header">
            <div class="record-info">
                <span class="detail-label">姓名：</span>
              <span class="record-name">{{ record.username }}</span>
                <span class="detail-label">考生号：</span>
              <span class="record-num">{{ record.usernum }}</span>
            </div>
            <span class="record-time">{{ record.createTime }}</span>
          </div>
          
          <div class="record-details">
            <div class="detail-row">
              <div class="detail-item">
                <span class="detail-label">省份：</span>
                <span class="detail-value">{{ record.province }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">科类：</span>
                <span class="detail-value">{{ record.subject }}</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-item">
                <span class="detail-label">总分：</span>
                <span class="detail-value">{{ record.totalscore }}分</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">省内排名：</span>
                <span class="detail-value">第{{ record.provincialranking }}名</span>
              </div>
            </div>
            <div class="detail-row">
              <div class="detail-item">
                <span class="detail-label">批次：</span>
                <span class="detail-value">{{ record.batch }}</span>
              </div>
            </div>
          </div>

          <div class="volunteer-section">
            <h4 class="volunteer-title">填报志愿</h4>
            <div class="volunteer-list">
              <div class="volunteer-item">
                <span class="volunteer-order">第1志愿</span>
                <span class="volunteer-school">{{ record.school1 || '空' }}</span>
                <span class="volunteer-major">{{ record.major1 || '-' }}</span>
                <span :class="['volunteer-adjust', (record.transfer1 === '是' || record.transfer1 === '0') ? 'yes' : 'no']">
                  {{ (record.transfer1 === '是' || record.transfer1 === '0') ? '服从调剂' : '不服从调剂' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[10, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { ElSpin, ElButton, ElPagination, ElIcon } from "element-plus";
import { DocumentEmpty } from "@element-plus/icons-vue";
import { getMockRecords } from "@/api/mockRecordApi";

export default {
  name: "MocksRecord",
  components: {
    ElSpin,
    ElButton,
    ElPagination,
    ElIcon,
    DocumentEmpty,
  },
  setup() {
    const router = useRouter();
    const loading = ref(true);
    const records = ref([]);
    const total = ref(0);
    const pageNum = ref(1);
    const pageSize = ref(10);

    const fetchRecords = async () => {
      loading.value = true;
      try {
        const response = await getMockRecords({
          pageNum: pageNum.value,
          pageSize: pageSize.value,
        });
        
        if (response.data.code === 200) {
        records.value = response.data.data.list || [];
        total.value = response.data.data.total || 0;
        console.log('获取到的记录:', records.value);
        if (records.value.length > 0) {
          console.log('第一条记录的所有字段:', Object.keys(records.value[0]));
          console.log('school1:', records.value[0].school1);
          console.log('School1:', records.value[0].School1);
        }
      }
      } catch (error) {
        console.error("获取模拟填报记录失败:", error);
      } finally {
        loading.value = false;
      }
    };

    const handleSizeChange = (val) => {
      pageSize.value = val;
      fetchRecords();
    };

    const handleCurrentChange = (val) => {
      pageNum.value = val;
      fetchRecords();
    };

    const goToMock = () => {
      router.push("/mocks");
    };

    const getFieldValue = (record, fieldPrefix, index) => {
      const lowerField = `${fieldPrefix}${index}`;
      const upperField = `${fieldPrefix.charAt(0).toUpperCase()}${fieldPrefix.slice(1)}${index}`;
      if (record[lowerField] !== undefined && record[lowerField] !== null) {
        return record[lowerField];
      }
      if (record[upperField] !== undefined && record[upperField] !== null) {
        return record[upperField];
      }
      return '';
    };

    const getTransferValue = (record, index) => {
      const value = getFieldValue(record, 'transfer', index);
      if (value) return value;
      if (index === 2 && record['transfe2'] !== undefined && record['transfe2'] !== null) {
        return record['transfe2'];
      }
      return '';
    };

    onMounted(() => {
      fetchRecords();
    });

    return {
      loading,
      records,
      total,
      pageNum,
      pageSize,
      fetchRecords,
      handleSizeChange,
      handleCurrentChange,
      goToMock,
      getFieldValue,
      getTransferValue,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1440px;
  width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 16px;
}

.main-title {
  font-size: 28px;
  color: #303133;
  margin-bottom: 10px;
}

.subtitle {
  color: #909399;
  font-size: 14px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.record-list {
  min-height: 300px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #909399;
}

.empty-icon {
  margin-bottom: 20px;
  color: #d9d9d9;
}

.empty-state p {
  margin-bottom: 20px;
}

.record-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin-bottom: 16px;
}

.record-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 20px;
}

.record-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.record-name-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.record-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.record-num-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.record-num {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.record-time {
  font-size: 13px;
  color: #909399;
  background: #fafafa;
  padding: 6px 14px;
  border-radius: 20px;
}

.record-details {
  margin-bottom: 20px;
}

.detail-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 12px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-label {
  font-size: 14px;
  color: #606266;
}

.detail-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.volunteer-section {
  background: #fafafa;
  border-radius: 8px;
  padding: 12px 16px;
}

.volunteer-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.volunteer-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.volunteer-item {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
  justify-content: flex-start;
}

.volunteer-order {
  font-weight: 600;
  color: #409eff;
  min-width: 60px;
}

.volunteer-school {
  color: #303133;
  font-weight: 500;
  flex: 1;
}

.volunteer-major {
  color: #67c23a;
  flex: 1;
}

.volunteer-adjust {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
}

.volunteer-adjust.yes {
  background: #e8f5e9;
  color: #67c23a;
}

.volunteer-adjust.no {
  background: #fef0f0;
  color: #f56c6c;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding: 20px 0;
}

@media (max-width: 768px) {
  .container {
    padding: 15px;
    margin-top: 70px;
  }

  .record-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .detail-row {
    flex-direction: column;
    gap: 8px;
  }

  .volunteer-item {
    flex-wrap: wrap;
  }

  .volunteer-school,
  .volunteer-major {
    flex: none;
  }
}
</style>